
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plaid-exchange/docs/authentication",
      function () {
        return require("private-next-pages/plaid-exchange/docs/authentication/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plaid-exchange/docs/authentication"])
      });
    }
  